export const docsConstants = {
    SET_PARAMS_REQUEST: 'DOCS_SET_PARAMS_REQUEST',

    GETALL_REQUEST: 'DOCS_GETALL_REQUEST',
    GETALL_SUCCESS: 'DOCS_GETALL_SUCCESS',
    GETALL_FAILURE: 'DOCS_GETALL_FAILURE',

    DELETE_REQUEST: 'DOCS_DELETE_REQUEST',
    DELETE_SUCCESS: 'DOCS_DELETE_SUCCESS',
    DELETE_FAILURE: 'DOCS_DELETE_FAILURE',

    UPLOAD_REQUEST: 'DOCS_UPLOAD_REQUEST',
    UPLOAD_SUCCESS: 'DOCS_UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'DOCS_UPLOAD_FAILURE',

    GET_REQUEST: 'DOCS_GET_REQUEST',
    GET_SUCCESS: 'DOCS_GET_SUCCESS',
    GET_FAILURE: 'DOCS_GET_FAILURE',

    ADD_REQUEST: 'DOCS_ADD_REQUEST',
    ADD_SUCCESS: 'DOCS_ADD_SUCCESS',
    ADD_FAILURE: 'DOCS_ADD_FAILURE',

    UPDATE_REQUEST: 'DOCS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'DOCS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'DOCS_UPDATE_FAILURE',

    UPDATE_FIELD_REQUEST: 'DOCS_UPDATE_FIELD_REQUEST',
    UPDATE_FIELD_SUCCESS: 'DOCS_UPDATE_FIELD_SUCCESS',
    UPDATE_FIELD_FAILURE: 'DOCS_UPDATE_FIELD_FAILURE',

    CAT_GETALL_REQUEST: 'DOCS_CAT_GETALL_REQUEST',
    CAT_GETALL_SUCCESS: 'DOCS_CAT_GETALL_SUCCESS',
    CAT_GETALL_FAILURE: 'DOCS_CAT_GETALL_FAILURE',

    CAT_DELETE_REQUEST: 'DOCS_CAT_DELETE_REQUEST',
    CAT_DELETE_SUCCESS: 'DOCS_CAT_DELETE_SUCCESS',
    CAT_DELETE_FAILURE: 'DOCS_CAT_DELETE_FAILURE',

    CAT_GET_REQUEST: 'DOCS_CAT_GET_REQUEST',
    CAT_GET_SUCCESS: 'DOCS_CAT_GET_SUCCESS',
    CAT_GET_FAILURE: 'DOCS_CAT_GET_FAILURE',

    CAT_ADD_REQUEST: 'DOCS_CAT_ADD_REQUEST',
    CAT_ADD_SUCCESS: 'DOCS_CAT_ADD_SUCCESS',
    CAT_ADD_FAILURE: 'DOCS_CAT_ADD_FAILURE',

    CAT_UPDATE_REQUEST: 'DOCS_CAT_UPDATE_REQUEST',
    CAT_UPDATE_SUCCESS: 'DOCS_CAT_UPDATE_SUCCESS',
    CAT_UPDATE_FAILURE: 'DOCS_CAT_UPDATE_FAILURE',

    CAT_UPDATE_FIELD_REQUEST: 'DOCS_CAT_UPDATE_FIELD_REQUEST',
    CAT_UPDATE_FIELD_SUCCESS: 'DOCS_CAT_UPDATE_FIELD_SUCCESS',
    CAT_UPDATE_FIELD_FAILURE: 'DOCS_CAT_UPDATE_FIELD_FAILURE',
}